import { StepUnexpected } from './steps/StepUnexpected';
import { StepMade } from './steps/StepMade';
import { StepProud } from './steps/StepProud';
import { StepAbout } from './steps/StepAbout';
import { StepSubmission } from './steps/StepSubmission';
import { StepEnd } from './steps/StepEnd';
import { WizardStepKind, type WizardStepDef } from './types';

export const WIZARD_STEPS: WizardStepDef[] = [
    { id: 'unexpected', kind: WizardStepKind.Question, Component: StepUnexpected },
    { id: 'made', kind: WizardStepKind.Question, Component: StepMade },
    { id: 'proud', kind: WizardStepKind.Question, Component: StepProud },
    { id: 'about', kind: WizardStepKind.Question, Component: StepAbout },
    { id: 'submission', kind: WizardStepKind.Form, Component: StepSubmission },
    { id: 'end', kind: WizardStepKind.End, Component: StepEnd },
];
